var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1879 25.4541C19.7934 25.4541 20.2848 25.9455 20.2848 26.551C20.2848 27.1564 19.7934 27.6479 19.1879 27.6479C18.5825 27.6479 18.091 27.1564 18.091 26.551C18.091 25.9455 18.5825 25.4541 19.1879 25.4541ZM23.959 25.4541C24.5645 25.4541 25.0559 25.9455 25.0559 26.551C25.0559 27.1564 24.5645 27.6479 23.959 27.6479C23.3536 27.6479 22.8621 27.1564 22.8621 26.551C22.8621 25.9455 23.3536 25.4541 23.959 25.4541ZM11.9045 14.4964H13.4541C13.7557 14.4964 14.0208 14.6977 14.1016 14.989C14.1016 14.989 14.1021 14.989 14.1021 14.9895C14.6241 16.8686 15.7521 20.929 16.2763 22.8152C16.5223 23.7015 17.3296 24.3146 18.2487 24.3146H24.8716C25.8114 24.3146 26.6307 23.6748 26.8581 22.7628C27.3196 20.9186 28.2359 17.2526 28.2359 17.2526C28.2867 17.0492 28.2408 16.8332 28.1116 16.6679C27.9823 16.5021 27.7843 16.4055 27.5743 16.4055H18.091C17.7147 16.4055 17.4092 16.711 17.4092 17.0874C17.4092 17.4637 17.7147 17.7692 18.091 17.7692H26.701L25.5348 22.4334C25.459 22.7377 25.1852 22.951 24.8716 22.951H18.2487C17.9416 22.951 17.6721 22.7459 17.5897 22.4503C17.0656 20.5641 15.9376 16.5032 15.4156 14.6241C15.1717 13.7432 14.3688 13.1328 13.4541 13.1328H11.9045C11.5281 13.1328 11.2227 13.4383 11.2227 13.8146C11.2227 14.191 11.5281 14.4964 11.9045 14.4964Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cartIcon.7ba3173eb6690bc0050983d4b253c926.svg";
export { ForwardRef as ReactComponent };